'use strict';

module.exports = function( obj, prop, propDefaultValue ) {
	if ( obj && obj[ prop ] === undefined ) {
		obj[ prop ] = propDefaultValue;
	}
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/wpapi/lib/util/ensure.js
 ** module id = 403
 ** module chunks = 0
 **/